import React from "react";
import { Card, Text, EmptyState } from "components";
import { Stage, PlusIcon } from "./_shared";

export const surfaceEntries = [
  {
    id: "card", name: "Card", group: "Cards & surfaces", status: "live",
    description: "Base surface the GameCard / HeroCard / panels build on. Accent bar (left or top, solid or gradient), a brand spotlight treatment, padding, dashed and interactive variants.",
    props: [
      { name: "accent", type: "'none'|'teal'|'gold'|'gradient'", default: "'none'", description: "Accent bar color" },
      { name: "accentEdge", type: "'left'|'top'", default: "'left'", description: "Bar position" },
      { name: "spotlight", type: "bool", default: "false", description: "Brand featured card: top gradient bar + teal border + glow" },
      { name: "padding", type: "'none'|'sm'|'md'|'lg'", default: "'md'", description: "Inset" },
      { name: "dashed / interactive", type: "bool", default: "false", description: "New-game tile / hover lift" },
    ],
    variants: [
      { label: "Left accents", render: () => <Stage width={420}><div style={{ display: "grid", gridTemplateColumns: "1fr 1fr", gap: 12 }}><Card interactive><Text variant="h3">Plain</Text><Text variant="caption" tone="muted">interactive</Text></Card><Card accent="teal"><Text variant="h3">Teal (left)</Text></Card><Card accent="gold"><Text variant="h3">Gold (left)</Text></Card><Card dashed><Text variant="h3" tone="muted">Dashed</Text></Card></div></Stage> },
      { label: "Top accents", render: () => <Stage width={420}><div style={{ display: "grid", gridTemplateColumns: "1fr 1fr", gap: 12 }}><Card accent="teal" accentEdge="top"><Text variant="h3">Teal (top)</Text></Card><Card accent="gradient" accentEdge="top"><Text variant="h3">Gradient (top)</Text></Card></div></Stage> },
      { label: "Spotlight (brand featured)", render: () => <Stage width={300}><Card spotlight padding="lg"><Text variant="eyebrow">Now playing tonight</Text><Text variant="h2" style={{ marginTop: 6 }}>Office Olympics 2026</Text><Text variant="caption" tone="muted">3 rounds · 90 clues · ready when you are</Text></Card></Stage> },
      { label: "Game surface", render: () => <Stage surface="game" width={240}><Card accent="gradient" accentEdge="top"><Text variant="h3">On dark</Text><Text variant="caption" tone="muted">surface-aware</Text></Card></Stage> },
    ],
    code: `import { Card, Text } from "components";

<Card accent="teal">…</Card>
<Card accent="gradient" accentEdge="top">…</Card>
<Card spotlight padding="lg">
  <Text variant="eyebrow">Now playing tonight</Text>
  <Text variant="h2">Office Olympics 2026</Text>
</Card>`,
  },
  {
    id: "empty-state", name: "EmptyState", group: "Cards & surfaces", status: "live",
    description: "Zero-games / empty-filter block. Composes Button. (No MUI equivalent.)",
    props: [
      { name: "icon, title, body", type: "node", description: "Content" },
      { name: "action / secondaryAction", type: "node | {label,onClick,icon}", description: "CTAs" },
      { name: "bordered", type: "bool", default: "false", description: "Own dashed surface" },
    ],
    variants: [
      { label: "Bordered", render: () => <Stage width={400}><EmptyState bordered icon={<PlusIcon />} title="Create your first game" body="Build a board, write your clues, and launch it for your players." action={{ label: "New Game", icon: <PlusIcon />, onClick: () => {} }} /></Stage> },
    ],
    code: `import { EmptyState } from "components";

<EmptyState
  bordered
  icon={<PlusIcon />}
  title="Create your first game"
  body="Build a board, write your clues, and launch it for your players."
  action={{ label: "New Game", icon: <PlusIcon />, onClick: create }}
/>`,
  },
];
